import { Text } from "@mantine/core";
import { modals } from "@mantine/modals";

type ConfirmOptions = {
  title: string;
  /** One sentence stating the consequence (spec §7). */
  consequence: string;
  confirmLabel?: string;
  /** Red confirm button for destructive / irreversible actions. Default true. */
  danger?: boolean;
};

/**
 * Asks for confirmation; resolves true on confirm, false on cancel/dismiss.
 * `if (await confirmAction({...})) mutation.mutate(...)`.
 */
export function confirmAction({
  title,
  consequence,
  confirmLabel = "Confirm",
  danger = true,
}: ConfirmOptions): Promise<boolean> {
  return new Promise((resolve) => {
    let settled = false;
    const done = (v: boolean) => {
      if (!settled) resolve(v);
      settled = true;
    };
    modals.openConfirmModal({
      title,
      centered: true,
      children: <Text size="sm">{consequence}</Text>,
      labels: { confirm: confirmLabel, cancel: "Cancel" },
      confirmProps: { color: danger ? "red" : undefined, "data-testid": "confirm-ok" } as Record<string, unknown>,
      cancelProps: { "data-testid": "confirm-cancel" } as Record<string, unknown>,
      onConfirm: () => done(true),
      onCancel: () => done(false),
      onClose: () => done(false),
    });
  });
}
